import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import bindAllActions from '../../common/bindAllActions'
import HeatStressGroupMembers from './HeatStressGroupMembers'
import HeatStressAlertDevices from './HeatStressAlertDevices'
import SubscriptionDisplayCard from '../payment/SubscriptionDisplayCard'
import { getHeatStressTier, HEAT_STRESS_FEATURES } from '../payment/index'
import './HeatStressAlerts.less'

function HeatStressAlerts ({ user, socialActions, userActions, device }) {
  // Get current heat stress tier
  const currentTier = getHeatStressTier(user?.info || user)

  // Get the subscription productName
  let subscriptionProductName = null

  if (currentTier === 'free') {
    subscriptionProductName = 'heat-stress-free'
  } else {
    // Find the actual subscription in user's subscriptions
    const subscriptions = user?.info?.payments?.subscriptions || []
    const heatStressSub = subscriptions.find(sub =>
      sub.productName?.startsWith('heat-stress-') &&
      (!sub.macAddress || sub.macAddress === 'Account')
    )
    subscriptionProductName = heatStressSub?.productName || 'heat-stress-free'
  }

  // Get feature values for current tier
  const smsFeature = HEAT_STRESS_FEATURES.find(f => f.label === 'SMS alerts')
  const recipientsFeature = HEAT_STRESS_FEATURES.find(f => f.label === 'Notified users')

  const smsValue = smsFeature?.[currentTier]
  const recipientsValue = recipientsFeature?.[currentTier]

  // Render feature details
  const renderFeatureDetails = () => {
    if (currentTier === 'free') {
      return <div className="feature-detail">Email Only</div>
    }

    return (
      <>
        <div className="feature-detail">Email + {smsValue}</div>
        {recipientsValue && (
          <div className="feature-detail">
            {recipientsValue.replace('up to ', '').replace(' people', '')} SMS Recipients
          </div>
        )}
      </>
    )
  }

  return (
    <div className='alert-heat-stress'>
      <div className='block'>
        <h3>Heat Stress Alerts</h3>
        <p>Monitor heat stress conditions and notify your team when thresholds are exceeded. Manage your alert recipients and notification settings to keep everyone safe.</p>

        <SubscriptionDisplayCard subscription={subscriptionProductName}>
          {renderFeatureDetails()}
        </SubscriptionDisplayCard>
        <p>
          <Link to="/subscriptions">Manage Heat Stress subscription</Link>
        </p>
      </div>

      <div className='block'>
        <HeatStressGroupMembers />
      </div>

      <div className='block'>
        <HeatStressAlertDevices />
      </div>
    </div>
  )
}

HeatStressAlerts.propTypes = {
  user: PropTypes.object.isRequired,
  socialActions: PropTypes.object.isRequired,
  userActions: PropTypes.object.isRequired,
  device: PropTypes.object.isRequired
}

HeatStressAlerts.displayName = 'HeatStressAlerts'

export default bindAllActions(HeatStressAlerts)
